import { defaultFill } from '../utils/constants';
var muiCaretDownGlyph = {
    paths: [
        {
            path: 'M15.7091115,2.20911154 L8.70911154,9.20911154 C8.31858724,9.59963583 7.68542227,9.59963583 7.29489797,9.20911154 L0.294897973,2.20911154 C-0.335066888,1.57914667 0.111099904,0.502004755 1.00200475,0.502004755 L15.0020048,0.502004755 C15.8929096,0.502004755 16.3390764,1.57914667 15.7091115,2.20911154 Z',
            fill: defaultFill,
        },
    ],
    title: 'Caret Down',
    width: 16,
    height: 10,
};
var muiCaretDown = {
    base: muiCaretDownGlyph,
};
export { muiCaretDown };
//# sourceMappingURL=caretDown.js.map